export enum RequestType {
  dotArr = 'ENDOWMENT_LEASING',
  campaigns = 'CAMPAIGN',
  function = 'FUNCTION',
  provisional = 'PROVISIONAL',
  proyect = 'PROJECT',
  generalServices = 'GENERAL_SERVICES',
  didactic = 'EDUCATIONAL',
  innerRoute = 'INNER_ROUTE',
  loan = 'LOAN',
  transfers = 'TRANSFERS',
  judgements = 'JUDGEMENTS',
  redPlates = 'REDPLATES',
  es = 'E-S',
  leasing = 'LEASING',
  vo = 'VO'
}

export enum RequestsPermissions {
  dotArr = 'ENDOWMENT_LEASING',
  campaigns = 'CAMPAIGN',
  function = 'FUNCTION',
  provisional = 'PROVISIONAL',
  didactic = 'EDUCATIONAL',
  generalServices = 'GENERAL_SERVICES',
  innerRoute = 'INNER_ROUTE',
  loanCarPool = 'LOAN_CAR_POOL',
  loanWedding = 'LOAN_WEDDING',
  loanLongTerms = 'LOAN_LONG_TERMS',
  proyect = 'PROJECT',
  judgements = 'JUDGEMENTS',
  transfers = 'TRANSFERS',
  redPlates = 'RED_PLATES',
  redPlatesApprove = 'RED_PLATES_APPROVE',
  es = 'E-S',
  vo = 'VO',
  // CRMSP-7485 - Empleados VO
  companyAdminVO = 'COMPANY_ADMINVO'
}

export enum RequestTypeTranslation {
  dotArr = 'Arrendamiento y Dotación',
  dot = 'Dotación',
  leasing = 'Arrendamiento',
  employeeLeasing = 'Leasing',
  campaigns = 'Campañas',
  function = 'Función',
  provisional = 'Provisionales',
  proyect = 'Proyecto',
  generalServices = 'Servicios Generales',
  didactic = 'Fin Didáctico',
  innerRoute = 'Recorrido Interior',
  loan = 'Préstamos',
  transfers = 'Cesiones',
  judgements = 'Dictámenes',
  redPlates = 'Placas Rojas',
  es = 'Entrada/Salida'
}
